import { render, staticRenderFns } from "./CompanyFulfillmentsOmsEdit.vue?vue&type=template&id=48ec0df0&scoped=true&"
import script from "./CompanyFulfillmentsOmsEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyFulfillmentsOmsEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFulfillmentsOmsEdit.vue?vue&type=style&index=0&id=48ec0df0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ec0df0",
  null
  
)

export default component.exports